import { INode } from '@/types/INode';
import { IContact } from './IContact';
import { IGroup } from './IGroup';


export class Group implements IGroup {
    _id: any;
    version:number=0
    idn:string=""
    _err:any={}
    parent_id:any
    type:string="group"
    fnd:string=""
    del:number=0


    owner:string="";

    contacts: string="";

}